import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { AlertComponent } from '@app/shared/components/alert/alert.component';

@Component({
  selector: 'app-profile-destroy-finish',
  templateUrl: './profile-destroy-finish.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TopNavbarComponent,
    LoyaltyClubHeaderComponent,
    TranslatePipe,
    LoyaltyClubFooterComponent,
    AlertComponent,
  ],
})
export class ProfileDestroyFinishComponent {
  private settingsService = inject(SettingsService);

  protected loyaltyClubName = this.settingsService.settings.name;
}
